export default class Company {
  constructor({ id, name, description } = {}) {
    this.id = id || '00000000-0000-0000-0000-000000000000',
    this.name = name,
    this.description = description
  }
}
